import React, { useContext, useRef, useState } from 'react';
import {
  Button,
  Text,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react';
import { useMutation } from '@apollo/client';
import get from 'lodash/get';

import SpinnerContext from '../../../contexts/SpinnerContext';
import { useUser } from '../../../contexts/UserContext';
import { SEND_UPS_EMAIL } from '../query';
import { useCustomToast } from '../../../hooks/useCustomToast';

export const SendUPSEmailButton = ({ where, refetch, totalUsers }) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const onAlertClose = () => setAlertOpen(false);
  const toast = useCustomToast();
  const cancelRef = useRef();
  const { toggleSpinner } = useContext(SpinnerContext);
  const [sendUPSEmail] = useMutation(SEND_UPS_EMAIL);

  const handleSendActivityCheck = async () => {
    try {
      toggleSpinner(true);

      await sendUPSEmail({
        variables: {
          where,
        },
      });

      await refetch();
      toast({
        title: 'Erfolg!',
        description: `UPS E-mail an ${totalUsers} User versendet.`,
        status: 'success',
      });
    } catch (error) {
      console.log(error);
      toast({
        description: get(error, 'graphQLErrors.0.message', 'Ein Fehler ist aufgetreten!'),
        status: 'error',
      });
    }
    setAlertOpen(false);
    toggleSpinner(false);
  };

  return (
    <>
      <Button size="sm" colorScheme="yellow" onClick={() => setAlertOpen(true)} disabled={totalUsers === 0}>
        UPS Info senden
      </Button>

      <AlertDialog isOpen={alertOpen} leastDestructiveRef={cancelRef} onClose={onAlertClose}>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Bist Du sicher?
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text mb="4">Möchtest du die UPS Info E-mail an {totalUsers} User senden?</Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onAlertClose}>
              Abbrechen
            </Button>
            <Button colorScheme="orange" type="submit" ml={3} onClick={handleSendActivityCheck}>
              UPS Info senden
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
